<template>
    <div class="role-page full-height">
        <table-con>
            <div slot="breadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/bad' }">{{$t('laund.laund1')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('laund.laund2')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div slot="search">
                <el-row class="search-row">
                    <el-col :span="6" class="display-row">
                        <div style="width:150px" class="query-title">{{$t('laund.laund3')}}:</div>
                        <div class="flex1">
                            <el-input  :placeholder="$t('laund.laund4')" clearable v-model="queryInfo.name" size="small" @keyup.enter.native="searchList">
                            </el-input>
                        </div>
                    </el-col>
                    <el-col :span="18" class="display-row">
                        <div style="text-align: right; width: 100%; padding-right: 10px">

                            <el-button class="search-btn btn-gray" @click="queryInfoClear">{{$t('laund.laund5')}}</el-button>
                            <el-button class="search-btn btn-blue" @click="searchList">{{$t('laund.laund6')}}</el-button>
                            <el-button class="search-btn btn-green" @click="doApply">{{$t('laund.laund7')}}</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div slot="table" class="full-height display-col" style="padding:10px">
                <el-table :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" :data="messageList" border>
                    <el-table-column type="index" align="center" :label="$t('wzbg.wz6')"  min-width="60"></el-table-column>
                    <el-table-column :label="$t('createOrder.createOrder10')" align="center"  min-width="80">
                        <template v-slot="scope">
                            <el-button class="list-btn btn-green" @click="doCopy(scope.row)">{{$t('laund.laund8')}}</el-button>
                            <el-button class="list-btn btn-deepblue" @click="doEdit(scope.row)">{{$t('laund.laund9')}}</el-button>
                            <el-button class="list-btn btn-red" @click="drop(scope.row)">{{$t('laund.laund10')}}</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" align="center" :label="$t('laund.laund3')"  min-width="120">
                    </el-table-column>
                    <el-table-column prop="size" :label="$t('laund.laund11')" align="center"  min-width="125">
                    </el-table-column>
                    <el-table-column prop="material" :label="$t('laund.laund12')" align="center"  min-width="125">
                    </el-table-column>
                    <el-table-column :label="$t('laund.laund13')" align="center"  min-width="280">
                        <template v-slot="scope">
                            <div class="imgBox">
                                <div class="img" v-if="scope.row.icon1&&scope.row.icon1.length>0">
                                    <img :src="scope.row.icon1" alt="" class="list-image">
                                </div>
                                <div class="img" v-if="scope.row.icon2&&scope.row.icon2.length>0">
                                    <img :src="scope.row.icon2" alt="" class="list-image">
                                </div>
                                <div class="img" v-if="scope.row.icon3&&scope.row.icon3.length>0">
                                    <img :src="scope.row.icon3" alt="" class="list-image">
                                </div>
                                <div class="img" v-if="scope.row.icon4&&scope.row.icon4.length>0">
                                    <img :src="scope.row.icon4" alt="" class="list-image">
                                </div>
                                <div class="img" v-if="scope.row.icon5&&scope.row.icon5.length>0">
                                    <img :src="scope.row.icon5" alt="" class="list-image">
                                </div>
                                <div class="img" v-if="scope.row.icon6&&scope.row.icon6.length>0">
                                    <img :src="scope.row.icon6" alt="" class="list-image">
                                </div>
                                <div class="img" v-if="scope.row.icon7&&scope.row.icon7.length>0">
                                    <img :src="scope.row.icon7" alt="" class="list-image">
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="notes" :label="$t('laund.laund14')" align="center"  min-width="220">
                    </el-table-column>
                    <el-table-column prop="company" :label="$t('laund.laund15')" align="center"  min-width="125">
                    </el-table-column>
                    <el-table-column prop="residence" :label="$t('laund.laund46')" align="center"  min-width="125">
                    </el-table-column>
                    <!-- <el-table-column prop="telephone" :label="$t('laund.laund16')" align="center"  min-width="125">
                    </el-table-column>
                    <el-table-column prop="email" align="center" :label="$t('laund.laund17')"  min-width="125">
                    </el-table-column> -->
                    <el-table-column prop="createTime" :label="$t('laund.laund18')" align="center"  min-width="160" :formatter="formatDate">
                    </el-table-column>
                    <el-table-column prop="remarks" :label="$t('laund.laund19')" align="center"  min-width="220">
                    </el-table-column>
                </el-table>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum" :page-sizes="[5, 10, 20, 50, 100, 200]" :pager-count="5" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
            </div>
        </table-con>

        <lx-temp :visible.sync="isVisibleTemp" :title="tempTitle" :id="tempId" :tempType="tempType" @success="onSuccess"></lx-temp>
    </div>
</template>

<script>
import tableCon from "../../views/tableContainer";
import LxTemp from "./cmp/LxTemp/index";

export default {
    components: { tableCon, LxTemp },
    data() {
        return {
            isVisibleTemp: false, // 显示水标模板弹框
            tempTitle: "", // dialog标题
            curIndex: 0, // 默认选中第0个
            imgurl: "",
            listObj: [],
            imgDataObj: {
                policy: "",
                signature: "",
                key: "",
                ossaccessKeyId: "",
                dir: "",
                host: "",
                timeStamp: "",
            },
            replyInfos: {
                orderId: "",
                remark: "",
                badPicture1: ""
            },
            queryInfo: {
                name: "",
                pageSize: 10,
                pageNum: 1,
            },
            messageList: [],
            imgDialogVisible: false,
            total: 0,
            tempId: null, // 模板id
            tempType: ''
        };
    },
    methods: {
        // 模板修或创建成功
        onSuccess() {
            this.isVisibleTemp = false;
            this.queryInfo.pageNum = 1;
            this.getMessageList();
        },
        // 新建模板
        doApply() {
            this.tempId = "";
            this.tempTitle = this.$t('laund.laund7');
            this.tempType = 'add'
            this.isVisibleTemp = true;
        },
        // 编辑模板
        doEdit({ id }) {
            this.tempId = id;
            this.tempTitle = this.$t('laund.laund20');
            this.tempType = 'edit'
            this.isVisibleTemp = true;
        },
        // 复制模板
        doCopy({ id }) {
            this.tempId = id;
            this.tempTitle = this.$t('laund.laund21');
            this.tempType = 'copy'
            this.isVisibleTemp = true;
        },

        indexMethod(index) {
            return (this.pageNum - 1) * this.pageSize + index + 1;
        },
        formatDate(row, column, cellValue, index) {
            //交易时间地方的时间格式化
            if (cellValue == null || cellValue == "") return "";
            let date = new Date(parseInt(cellValue) * 1000); //时间戳为10位需*1000，如果为13位的话不需乘1000。
            let Y = date.getFullYear() + "-";
            let M =
                date.getMonth() + 1 < 10
                    ? "0" + (date.getMonth() + 1) + "-"
                    : date.getMonth() + 1 + "-";
            let D =
                date.getDate() < 10
                    ? "0" + date.getDate() + " "
                    : date.getDate() + " ";
            let h =
                date.getHours() < 10
                    ? "0" + date.getHours() + ":"
                    : date.getHours() + ":";
            let m =
                date.getMinutes() < 10
                    ? "0" + date.getMinutes() + ":"
                    : date.getMinutes() + ":";
            let s =
                date.getSeconds() < 10
                    ? "0" + date.getSeconds()
                    : date.getSeconds();
            return Y + M + D + h + m + s;
        },
        handleSizeChange(newSize) {
            //分页
            this.queryInfo.pageSize = newSize;
            this.getMessageList();
        },
        handleCurrentChange(newPage) {
            //分页
            this.queryInfo.pageNum = newPage;
            this.getMessageList();
        },
        searchList() {
            //查询
            this.queryInfo.pageNum = 1;
            this.getMessageList();
        },
        async getMessageList() {
            //获取信息列表
            const { data: res } = await this.$http.get(
                "laundry/label/template/list",
                { params: this.queryInfo }
            );
            this.messageList = res.data.list;
            this.total = res.data.total;
            await this.messageList.forEach((item) => {
                // 把图片路径经过require处理
                // 从而获取新的图片资源地址
                if (item.icon1 != null && item.icon1 != "") {
                    item.icon1 = require("../../assets" + item.icon1);
                }
                if (item.icon2 != null && item.icon2 != "") {
                    item.icon2 = require("../../assets" + item.icon2);
                }
                if (item.icon3 != null && item.icon3 != "") {
                    item.icon3 = require("../../assets" + item.icon3);
                }
                if (item.icon4 != null && item.icon4 != "") {
                    item.icon4 = require("../../assets" + item.icon4);
                }
                if (item.icon5 != null && item.icon5 != "") {
                    item.icon5 = require("../../assets" + item.icon5);
                }
                if (item.icon6 != null && item.icon6 != "") {
                    item.icon6 = require("../../assets" + item.icon6);
                }
                if (item.icon7 != null && item.icon7 != "") {
                    item.icon7 = require("../../assets" + item.icon7);
                }
            });
        },
        //清空
        queryInfoClear() {
            this.queryInfo = {
                name: "",
                pageSize: 10,
                pageNum: 1,
            };
        },
        //删除
        drop(data) {
            this.$confirm(this.$t('laund.laund22'), {
                confirmButtonText: this.$t('laund.laund23'),
                confirmButtonClass: "form-btn btn-blue",
                cancelButtonText: this.$t('laund.laund24'),
                cancelButtonClass: "form-btn btn-gray",
                type: "warning",
            })
                .then((_) => {
                    this.$http
                        .post("laundry/label/template/insertAndEdit", {
                            id: data.id,
                            delFlag: "1",
                        })
                        .then((res) => {
                            if (res.data.code == 200) {
                                this.$message({
                                    type: "success",
                                    message: res.data.message,
                                });
                                this.getMessageList();
                            } else {
                                this.$message({
                                    type: "warning",
                                    message: res.data.message,
                                });
                            }
                        });
                })
                .catch((_) => {
                    this.$message({
                        type: "info",
                        message: this.$t('laund.laund25'),
                    });
                });
        },
    },
    watch: {},
    created() {
        this.getMessageList();
    },
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
    height: 60px !important;
}

.el-table .el-button--small {
    padding: 4px 10px;
}
.imgBox {
    display: flex;
}
.imgBox .img {
    margin-right: 2px;
    width: 35px !important;
    height: 35px !important;
}
.el-table img {
    width: 35px !important;
    height: 35px !important;
}
</style>
